import styled from 'styled-components'

export const HeaderContent = styled.div`
  padding-top: ${props => props.theme.spacing.sp16};
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 930px) {
    flex-direction: column;
    gap: ${props => props.theme.spacing.sp24};
  }
`

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  button {
    height: 35px;
    display: flex;
    align-items: center;
    gap: ${props => props.theme.spacing.sp8};
  }
`
